/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { AbstractControl } from "@angular/forms";
import moment from "moment";

export function dateValidator(type: "min" | "max", targetDate: Date) {
	return (control: AbstractControl): { [key: string]: boolean } | null => {
		const dateMoment = moment(control.value);
		const targetDateMoment = moment(targetDate);

		switch (type) {
			case "min":
				if (dateMoment?.isBefore(targetDateMoment)) {
					return { minDate: true };
				}

				break;
			case "max":
				if (dateMoment?.isAfter(targetDateMoment)) {
					return { maxDate: true };
				}
		}

		return null;
	};
}
